'use client';

import Divider from '@mui/material/Divider';
import { Fragment } from 'react';
import { SideBarBox } from '../SideBarBox';
import { RankingCard } from './RankingCard';

type Props = {
  title: string;
  events: (ImEventDto & { rank: number })[];
  customerSetting: CustomerSetting;
};

export const EventRanking: React.FC<Props> = ({
  title,
  events,
  customerSetting
}) => {
  return (
    <SideBarBox id="ranking" title={title}>
      {events.map((imEvent) => {
        return (
          <Fragment key={`ranking-${imEvent.rank}`}>
            <RankingCard
              imEvent={imEvent}
              rank={imEvent.rank}
              customerSetting={customerSetting}
            />
            <Divider />
          </Fragment>
        );
      })}
    </SideBarBox>
  );
};
